<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{ $t("courseOption.courseDetails") }}</span>
    </p>
    <el-form
      class="systemFont2 systemForm1"
      ref="detailFormRef"
      :model="detailForm"
      :rules="rules"
      label-width="80px"
      hide-required-asterisk
    >
      <el-row>
        <el-col :span="8" :offset="2">
          <!-- 课程类型 -->
          <el-form-item :label="$t('courseOption.courseType')" prop="courseType" style="text-align: left">
            <el-radio-group v-model="detailForm.courseType" @change="changeCourseType" :disabled="true">
              <el-radio label="0">{{ $t('courseOption.publicCourse') }}</el-radio>
              <el-radio label="1">{{ $t('courseOption.internalCourse') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 领域 -->
          <el-form-item :label="$t('courseOption.field')" prop="field">
            <el-select
              disabled
              v-model="detailForm.field"
              @change="changeField"
              size="systemSelect3"
              style="width: 100%"
              :placeholder="$t('common.pleaseSelect')"
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'field'
                )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 课程名称 -->
          <el-form-item
            :label="$t('courseOption.courseName')"
            prop="courseName"
          >
            <el-input
              :disabled="nonEdit"
              v-model="detailForm.courseName"
              size="reportContentInput"
              maxlength="125"
              :placeholder="$t('common.required')"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 目标学员 -->
          <el-form-item
            :label="$t('courseOption.targetStudents')"
            class="formItem"
          >
            <el-input
              :disabled="nonEdit"
              v-model="detailForm.targetStudents"
              type="textarea"
              size="reportLongContentInput"
              :rows="4"
              maxlength="600"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 形式 -->
          <el-form-item :label="$t('courseOption.defaultForm')" prop="form">
            <el-select
              v-if="detailForm.courseType === '1'"
              :disabled="nonEdit"
              v-model="detailForm.form"
              size="systemSelect3"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                label="录播"
                value="02"
              >
              </el-option>
            </el-select>
            <el-select
              v-else
              :disabled="nonEdit"
              v-model="detailForm.form"
              size="systemSelect3"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'form' && item.codeKey !== '02'
                )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 课程时长想改成天+小时+分钟---zhc -->
          <el-form-item
            :label="$t('courseOption.defaultDuration')"
            :rules="minutesRule"
            prop="minutes"
          >
            <el-row>
              <el-col :span="8">
                <el-select
                  filterable
                  :disabled="nonEdit"
                  v-model="days"
                  size="systemSelect3"
                  style="width: calc(100% - 1.2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.days") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  :disabled="nonEdit"
                  v-model="hours"
                  size="systemSelect3"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in hourList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.hours") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  :disabled="nonEdit"
                  v-model="minutes"
                  size="systemSelect3"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in durationList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.minutes") }}
              </el-col>
            </el-row>
            <!-- <el-time-picker
              :disabled="nonEdit"
              v-model="detailForm.duration"
              format="HH:mm"
              value-format="HH:mm"
              :picker-options="{
                selectableRange: '00:01:00 - 04:00:00'
              }"
              @focus="timePickerFocus"
              @blur="timePickerBlur"
              size="systemTimeSelect"
              style="width: 100%"
              arrow-control
              :placeholder="$t('common.selectDuration')"
            >
            </el-time-picker> -->
          </el-form-item>
          <!-- 证书 -->
          <el-form-item :label="$t('courseOption.certificate')">
            <el-input
              :disabled="nonEdit"
              v-model="detailForm.certificate"
              size="reportContentInput"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 内部课程特有字段 -->
          <div v-if="detailForm.courseType === '1'">
            <el-form-item :label="$t('courseOption.videoUrl')" prop="videoUrl">
              <el-input
                :disabled="nonEdit"
                v-model="detailForm.videoUrl"
                size="reportContentInput"
                maxlength="500"
                :placeholder="$t('common.required')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('courseOption.videoPassword')">
              <el-input
                :disabled="nonEdit"
                v-model="detailForm.videoPassword"
                size="reportContentInput"
                maxlength="50"
                :placeholder="$t('common.optional')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="height: 7.5px;"></div>
        </el-col>
        <el-col :span="8" :offset="4">
          <!-- 类别 -->
          <el-form-item :label="$t('courseOption.category')" prop="category">
            <el-select
              disabled
              v-if="reloadCategoryFlag"
              v-model="detailForm.category"
              size="systemSelect3"
              style="width: 100%"
              :placeholder="$t('common.pleaseSelect')"
            >
              <el-option
                v-for="item in detailForm.field == ''
                  ? []
                  : selection.filter(
                      item =>
                        item.searchKey === 'category' &&
                        item.fatherSearchKey === 'field' &&
                        item.fatherCodeKey === detailForm.field
                    )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 课程编号 -->
          <el-form-item
            :label="$t('courseOption.courseNumber')"
            prop="courseNumber"
          >
            <el-input
              disabled
              v-model="detailForm.courseNumber"
              size="reportContentInput"
              @input="validateNumber"
              @blur="formatNumber"
              maxlength="2"
              :placeholder="$t('courseOption.pleaseEnterNumber')"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 资格要求 -->
          <el-form-item
            :label="$t('courseOption.qualificationRequirements')"
            class="formItem"
          >
            <el-input
              :disabled="nonEdit"
              v-model="detailForm.requirements"
              type="textarea"
              size="reportLongContentInput"
              :rows="4"
              maxlength="600"
            ></el-input>
          </el-form-item>

          <div style="height: 7.5px;"></div>
          <!-- 上课语言 -->
          <el-form-item :label="$t('courseOption.classLanguage')">
            <el-select
              :disabled="nonEdit"
              v-model="detailForm.classLanguage"
              size="systemSelect3"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'languages'
                )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 人数限制 -->
          <el-form-item
            :label="$t('courseOption.numberLimit')"
            prop="numberLimit"
          >
            <el-input
              :disabled="nonEdit"
              v-model="detailForm.numberLimit"
              size="reportContentInput"
            ></el-input>
          </el-form-item>
          <!-- 课件链接 -->
          <el-form-item :label="$t('courseOption.coursewareLink')">
            <el-input
              :disabled="nonEdit"
              v-model="detailForm.coursewareLink"
              size="reportContentInput"
              maxlength="500"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="container">
        <el-col :span="20" :offset="2">
          <!-- 简介 -->
          <el-form-item
          :label="$t('courseOption.introduction')"
          class="formItem"
        >
          <el-input
            :disabled="nonEdit"
            v-model="detailForm.introduction"
            type="textarea"
            size="reportLongContentInput"
            :rows="7"
            maxlength="600"
          ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="foot-container">
      <el-col :span="12">
        <el-button
          style="margin-left: 0;"
          v-show="nonEdit"
          type="submit"
          @click.native.prevent="handleEdit"
          >{{ $t("common.edit") }}</el-button
        >
        <el-button
          style="margin-left: 0;"
          v-show="!nonEdit"
          type="submit"
          @click.native.prevent="handleSave"
          >{{ $t("common.save") }}</el-button
        >
      </el-col>
      <el-col :span="12">
        <el-button type="return" @click.native.prevent="handleReturn">{{
          $t("common.back")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    var validateMinutes = (rule, value, callback) => {
      if (this.days + this.hours + this.minutes == 0) {
        callback(new Error(this.$t("courseOption.pleaseEnterDuration")));
      } else {
        callback();
      }
    };
    let p0303 = JSON.parse(sessionStorage.getItem("p0303"));
    return {
      // 课程时长想改成天+小时+分钟---zhc
      // 时分秒
      durationList: [],
      hourList: [],
      dayList: [],
      days: 0,
      hours: 0,
      minutes: 0,
      // 时长校验
      minutesRule: {
        trigger: ["blur", "change"],
        validator: validateMinutes,
        type: "number"
      },
      p0303,
      // 不可编辑状态
      nonEdit: true,
      // 表单数据
      detailForm: {
        courseType: "0", // 课程类型：0-公共课程，1-内部课程
        field: "",
        category: "",
        courseNumber: "",
        courseName: "",
        targetStudents: "",
        requirements: "",
        form: "",
        classLanguage: "",
        duration: "",
        numberLimit: "",
        certificate: "",
        coursewareLink: "",
        introduction: "",
        videoUrl: "", // 视频地址（内部课程特有）
        videoPassword: "" // 视频密码（内部课程特有）
      },
      // 选择项数据
      selection: [],
      // 重新加载类别的下拉选项
      reloadCategoryFlag: true,
      // 校验规则
      rules: {
        courseType: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectCourseType"),
            trigger: "change"
          }
        ],
        field: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectField"),
            trigger: "change"
          }
        ],
        courseName: [
          {
            required: true,
            message: this.$t("courseOption.pleaseEnterCourseName"),
            trigger: "blur"
          }
        ],
        form: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectForm"),
            trigger: "blur"
          }
        ],
        // duration: [
        //   {
        //     required: true,
        //     message: this.$t("courseOption.pleaseEnterDuration"),
        //     trigger: "change"
        //   }
        // ],
        category: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectCategory"),
            trigger: "change"
          }
        ],
        courseNumber: [
          {
            required: true,
            message: this.$t("courseOption.pleaseEnterCourseNumber"),
            trigger: "blur"
          }
        ],
        numberLimit: [
          {
            pattern: /^(0|[1-9][0-9]*)$/,
            message: this.$t("courseOption.pleaseEnterPositiveInteger"),
            trigger: "blur"
          }
        ],
        videoUrl: [
          {
            required: true,
            message: this.$t("courseOption.pleaseEnterVideoUrl"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    // 初始化
    init() {
      let url = "/api/courseOption/init";
      this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.selection = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
      let detailurl = "/api/courseOption/detail";
      console.log(detailurl);
      this.$http
        .post(detailurl, {
          field: this.p0303.field,
          category: this.p0303.category,
          courseNumber: this.p0303.courseNumber
        })
        .then(response => {
          if (response.data.code === 200) {
            // this.selection = response.data.data;
            // this.detailForm.form = "01";
            // this.detailForm.classLanguage = "001";
            this.detailForm = response.data.data;
            // 拆分天时分
            this.queryDurationList(this.detailForm.duration);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 拆分天时分
    queryDurationList(val) {
      // 课程时长想改成天+小时+分钟---zhc
      let minuteTest = Number(val);
      // 取到分钟数
      let day = parseInt(minuteTest / 60 / 24 / 0.5) * 0.5;
      let hour = parseInt((minuteTest / 60) - day * 24);
      let min = parseInt(minuteTest - day * 24 * 60 - hour * 60);
      if (day > 0) {
        this.days = day;
      }
      if (hour > 0) {
        this.hours = hour;
      }
      if (min > 0) {
        this.minutes = min;
      }
    },
    // 获取分钟
    getDurationList() {
      for (let i = 0; i < 60; i++) {
        this.durationList.push(i);
      }
    },
    // 获取小时
    getHours() {
      for (let i = 0; i < 12; i++) {
        this.hourList.push(i);
      }
    },
    // 获取天
    getDayList() {
      this.dayList.push(0);
      for (let i = 1; i <= 10; i=i+0.5) {
        this.dayList.push(i);
      }
    },
    // 校验数字
    validateNumber() {
      this.$nextTick(function() {
        if (this.detailForm.courseNumber) {
          this.detailForm.courseNumber = this.detailForm.courseNumber.replace(
            /[\u4E00-\u9FA5]/g,
            ""
          );
          this.detailForm.courseNumber = this.detailForm.courseNumber.replace(
            /^\.+|[^\d.]/g,
            ""
          );
        }
      });
    },
    // 格式化数字
    formatNumber() {
      if (this.detailForm.courseNumber.length == 1) {
        this.detailForm.courseNumber = "0" + this.detailForm.courseNumber;
      }
    },
    // 领域的选中值发生变更的处理
    changeField() {
      // 清空类别下拉框的值
      this.detailForm.category = "";
      // 清空类别下拉框的报错信息
      this.$nextTick(function() {
        this.$refs.detailFormRef.clearValidate(["category"]);
      });
      // 重新加载类别下拉框的选项
      this.reloadCategoryFlag = false;
      this.reloadCategoryFlag = true;
    },
    // 课程类型变更的处理
    changeCourseType() {
      if (this.detailForm.courseType === '1') {
        // 内部课程：固定课程形式为录播（02）
        this.detailForm.form = '02';
        // 清空视频相关字段的校验
        this.$nextTick(function() {
          this.$refs.detailFormRef.clearValidate(["videoUrl"]);
        });
      } else {
        // 公共课程：重置课程形式为默认值
        this.detailForm.form = '01';
        // 清空内部课程特有字段
        this.detailForm.videoUrl = '';
        this.detailForm.videoPassword = '';
      }
    },
    // // 时间选择器获得焦点时的处理
    // timePickerFocus() {
    //   if (this.detailForm.duration == "" || this.detailForm.duration == null) {
    //     this.detailForm.duration = "00:45";
    //   }
    // },
    // // 时间选择器失去焦点时的处理
    // timePickerBlur() {
    //   this.$refs.detailFormRef.validateField(["duration"]);
    // },
    // 编辑按钮响应事件
    handleEdit() {
      this.nonEdit = false;
    },
    // 保存按钮响应事件
    handleSave() {
      this.$refs["detailFormRef"].validate(valid => {
        if (valid) {
          // 内部课程特有字段校验
          if (this.detailForm.courseType === '1' && !this.detailForm.videoUrl) {
            this.$message.error(this.$t("courseOption.pleaseEnterVideoUrl"));
            return;
          }

          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let durations = String(
            Number(this.days * 24 * 60) +
              Number(this.hours * 60) +
              Number(this.minutes)
          );
          let url = "/api/courseOption/update";
          this.detailForm.coursewareLink = (this.detailForm.coursewareLink || '').trim();
          this.detailForm.videoUrl = (this.detailForm.videoUrl || '').trim();
          this.detailForm.videoPassword = (this.detailForm.videoPassword || '').trim();
          this.detailForm.createUser = localStorage.getItem("userId");
          // alert(JSON.stringify(this.detailForm));
          this.$http
            .post(url, {
              category: this.detailForm.category,
              certificate: this.detailForm.certificate,
              classLanguage: this.detailForm.classLanguage,
              courseName: this.detailForm.courseName,
              courseNumber: this.detailForm.courseNumber,
              coursewareLink: this.detailForm.coursewareLink,
              createTime: this.detailForm.createTime,
              createUser: this.detailForm.createUser,
              duration: durations,
              field: this.detailForm.field,
              form: this.detailForm.form,
              introduction: this.detailForm.introduction,
              numberLimit: this.detailForm.numberLimit,
              qualificationRequirements: this.detailForm.requirements,
              targetStudents: this.detailForm.targetStudents,
              updateUser: localStorage.getItem("userId"),
              courseType: this.detailForm.courseType,
              videoUrl: this.detailForm.videoUrl,
              videoPassword: this.detailForm.videoPassword
            })
            .then(response => {
              if (response.data.code === 200) {
                loading.close();
                this.$message.success(response.data.data);
                this.nonEdit = true;
                this.init();
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 返回
    handleReturn() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/views/GreenJacketForum/P0302",
        query: {
          courseName: this.$route.query.courseName,
          field: this.$route.query.field,
          category: this.$route.query.category,
          currentPageCo: this.$route.query.currentPageCo,
          totalCo: this.$route.query.totalCo,
          pageSizeCo: this.$route.query.pageSizeCo
        }
      });
    }
  },
  mounted() {
    this.$route.query;
    this.init();
    this.getDurationList();
    this.getHours();
    this.getDayList();
  }
};
</script>

<style lang="scss" scoped>
.foot-container {
  margin: 40px auto 0 auto;
  height: 26px;
  width: 14%;
  text-align: center;
}

// el-form-item的label的行高度
.formItem >>> .el-form-item__label {
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0303.vue